import React from "react";
import { PieChart, Pie, Cell, Tooltip } from "recharts";

const PiechartPayable = ({ data, colors }) => {
  const hasData =
    data && data.length > 0 && data.some((item) => item.value > 0);
  const defaultData = [{ name: "No Data", value: 1 }];
  const DEFAULT_COLOR = "#dddddd";

  // Get Overdue amount to display in center
  const overdueEntry = data?.find((item) => item.name === "Overdue");
  const overdueAmount = overdueEntry?.value || 0;

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <p>{data.name}</p>
          <p>
            <strong>Amount:</strong> ₹ {data.value.toLocaleString()}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div style={{display:"flex", justifyContent:"center"}}>
      <PieChart width={238} height={215}>
        <Pie
          dataKey="value"
          data={hasData ? data : defaultData}
          cx={120}
          cy={110}
          outerRadius={90}
          innerRadius={50}
        >
          {(hasData ? data : defaultData).map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={
                hasData && colors[entry.name]
                  ? colors[entry.name]
                  : DEFAULT_COLOR
              }
            />
          ))}
        </Pie>

        {hasData && (
          <>
            <text
              x={120}
              y={110}
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="12"
              fontWeight="bold"
              fill="#6A6A6A"
            >
              ₹ {overdueAmount.toLocaleString()}
            </text>
            <text
              x={120}
              y={125}
              textAnchor="middle"
              dominantBaseline="middle"
              fontSize="11"
              fill="#6A6A6A"
            >
              Overdue
            </text>
          </>
        )}

        <Tooltip content={<CustomTooltip />} />
      </PieChart>
    </div>
  );
};

export default PiechartPayable;
